import { SelectOption } from '@spa/components/form-group/form-group.component';

export enum TitleCode {
  EMPTY = 'EMPTY',
  MS = 'MS',
  MR = 'MR',
  NOT_SPECIFIED = 'NOT_SPECIFIED'
}

const convertTitle = (titleStr: string | undefined): TitleCode => {
  let title: TitleCode;

  switch (titleStr) {
    case 'MS':
      title = TitleCode.MS;
      break;
    case 'MR':
      title = TitleCode.MR;
      break;
    case 'EMPTY':
      title = TitleCode.EMPTY;
      break;
    case 'NOT_SPECIFIED':
      title = TitleCode.NOT_SPECIFIED;
      break;
    default:
      throw new Error('Unknown customer title: ' + titleStr);
  }

  return title;
};

export const titlesOptions: ReadonlyArray<SelectOption> = Object.values(TitleCode).map((title) => ({
  value: title,
  name: title
}));

export default convertTitle;
